(ns iris.localstorage)

;; Taken from:
;; https://gist.github.com/daveliepmann/cf923140702c8b1de301

(defn item-set? 
  "Check whether the items exists in storage"
  [key]
  (.hasOwnProperty (.-localStorage js/window) key))

(defn set-item!
  "Set `key' in browser's localStorage to `val`."
  [key val]
  (.setItem (.-localStorage js/window) key val))

(defn get-item
  "Returns value of `key' from browser's localStorage."
  [key]
  (.getItem (.-localStorage js/window) key))

(defn remove-item!
  "Remove the browser's localStorage value for the given `key`"
  [key]
  (.removeItem (.-localStorage js/window) key))